import { fetch } from 'http-common';

import { DeliveryCodeDto } from 'types/api/orders.type';
import { SeasonConfig } from 'types/api/seasons.type';

type AvailableDeliveryCodesParams = {
  season: string;
  zone: string;
  warehouse: string;
  itemCode?: string;
  itemColorCode?: string;
  mainFabricCode?: string;
};

class CatalogueDataService {
  private http = fetch();

  private ep = '/v1/catalogue';

  public async getAvailableDeliveryCodes(params: AvailableDeliveryCodesParams) {
    return this.http.get<DeliveryCodeDto[]>(`${this.ep}/availableDeliveryCode`, { params });
  }

  public async getSectionConfig(availableOn: string) {
    return this.http.get<SeasonConfig[]>(`${this.ep}/section-config`, {
      params: { availableOn },
    });
  }
}

const catalogueDataService = new CatalogueDataService();

export { catalogueDataService };
